import { render, staticRenderFns } from "./ReportConversationModal.vue?vue&type=template&id=63948053&"
import script from "./ReportConversationModal.vue?vue&type=script&lang=js&"
export * from "./ReportConversationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports